import React, { Fragment, useState } from "react";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import useApiMutation from "src/Hooks/Shared/useApiMutation";
import EndPoints from "src/Constants/EndPoints";
import CSS from "csstype";
import { useTranslation } from "react-i18next";

function EditProfileModal(props: any) {
  const { t, i18n } = useTranslation();
  const { user } = AppStateHandler.getState();
  const {
    showModal,
    setModalVisibility,
    profileData,
    setValue,
    reset,
    handleSubmit,
    errors,
    register,
    cityData,
    stateData,
    refetchProfile,
  } = props;
  const { picture } = profileData;
  const [iconUrl, setIconUrl] = useState<any>(
    picture !== "" ? picture : "assets/images/profile-camera.png"
  );
  const [profilePic, setProfilePic] = useState<any>("");
  const [imgExt, setImgExt] = useState<string>("");


  const cameraIcon: CSS.Properties = {
    position: "absolute",
    top: "75%",
    right: "39%",
    fontSize: "24px",
    color: "darkslategray",
    cursor: "pointer",
  };

  const [updateProfile, { status }] = useApiMutation({
    onSuccess: (response) => {
      AppStateHandler.syncUser(response.data);
      reset(response.data.Items[0]);
      refetchProfile();
      setModalVisibility(false);
    },
  });

  const editProfile = async (params: any) => {
    if (Object.keys(errors).length !== 0 || status === "loading") {
      return;
    }
    try {
      await updateProfile({
        url: EndPoints.editProfile,
        data: {
          subId: user?.username,
          imgExtension: imgExt,
          imgBase64: profilePic,
          ...params,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fileSelectedHandler = async (imgs: any) => {
    const icon = imgs.length ? imgs[0] : null;
    if (icon) {
      try {
        const imgBase64 = await convertImagesToBase64(icon);
        const ext = imgBase64
          .split(",")[0]
          .replace("data:image/", "")
          .replace(";base64", "");
        setImgExt(ext);
        setIconUrl(URL.createObjectURL(icon));
        setProfilePic(imgBase64.split(",")[1]);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const convertImagesToBase64 = (file: File) => {
    return new Promise<any>((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = function () {
        resolve(fileReader.result);
      };
      fileReader.onerror = function (error) {
        console.log("Error: ", error);
        reject(error);
      };
    });
  };

  const hideModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(false);
  };

  return (
    <Fragment>
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        id="add_post"
        style={{ display: showModal ? "block" : "none" }}
        role={"dialog"}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0">
            <div className="modal-body p-3 p-md-5 custom_modal">
              <div className="">
                <form onSubmit={handleSubmit(editProfile)}>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <label className="mb-0">{t("Edit Account")}</label>
                  </div>
                  <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                    <div>
                      <div className="mb-3 position-relative"
                        style={{ textAlign: "center" }}
                      >
                        <img
                          width="160"
                          height="160"
                          className="rounded-circle object_fit"
                          alt=""
                          src={iconUrl}
                        ></img>
                        <label htmlFor="photos">
                          <i
                            style={cameraIcon}
                            className="fa fa-camera"
                            aria-hidden="true"
                          ></i>
                        </label>
                        <input
                          id="photos"
                          className="d-none"
                          type="file"
                          accept="image/*"
                          onChange={(e) => fileSelectedHandler(e.target.files)}
                        />
                      </div>
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t('First Name')}</label>
                      <input
                        name="name"
                        className="form-control"
                        placeholder={t("First Name")}
                        ref={register({ required: "*"+t("FirstName is required") })}
                      />
                      {errors.name && (
                        <span className="ml-3 text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t('Last Name')}</label>
                      <input
                        name="family_name"
                        className="form-control"
                        placeholder={t('Last Name')}
                        ref={register({ required: "*"+t("LastName is required") })}
                      />
                      {errors.family_name && (
                        <span className="ml-3 text-danger">
                          {errors.family_name.message}
                        </span>
                      )}
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t('Phone Number')}</label>
                      <input
                        name="phone_number"
                        className="form-control"
                        placeholder={t("Phone Number")}
                        ref={register({ required: "*"+t("Phone Number is required") })}
                      />
                      {errors.phone_number && (
                        <span className="ml-3 text-danger">
                          {errors.phone_number.message}
                        </span>
                      )}
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t('Select Wilaya')}</label>
                      <select
                        className={`form-control fz12 ${errors.state_id ? "is-invalid" : ""
                          }`}
                        ref={register({
                          required: {
                            value: true,
                            message: "*Wilaya is required",
                          },
                        })}
                        name="state_id"
                        onChange={(e) => {
                          setValue("city_id", "");
                        }}
                      >
                        <option value="">Select Wilaya</option>
                        {stateData.map((state: any) => (
                          <option key={state.id} value={state.id}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                      {errors.state_id && (
                        <span className="ml-3 text-danger">
                          {errors.state_id.message}
                        </span>
                      )}
                    </div>
                    <div className={`form-group ${i18n.dir() ==='rtl'?'text-right':''}`}>
                      <label>{t('Select Daira')}</label>
                      <select
                        className={`form-control fz12 ${errors.city_id ? "is-invalid" : ""
                          }`}
                        ref={register({
                          required: {
                            value: true,
                            message: "*Daira is required",
                          },
                        })}
                        name="city_id"
                      >
                        <option value="">Select Daira</option>
                        {cityData.map((city: any) => (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                      {errors.city_id && (
                        <span className="ml-3 text-danger">
                          {errors.city_id.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div/>
                    <div className="d-flex">
                      <button
                        type="button"
                        className={`btn custom_btn border text-secondary bg-transparent fz14 ${i18n.dir()=== "rtl" ? "ml-3":"mr-3"}`}
                        onClick={hideModal}
                      >
                        {t("Cancel")}
                      </button>
                      <button type="submit" className="btn custom_btn fz14">
                        <VisibilityToggle visible={status === "loading"}>
                          <span className="spinner-border spinner-border-sm"></span>
                          &nbsp; &nbsp;
                        </VisibilityToggle>
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <VisibilityToggle visible={showModal ? true : false}>
        <div
          className={`modal-backdrop fade ${showModal ? "show" : ""}`}
          onClick={() => setModalVisibility(false)}
        ></div>
      </VisibilityToggle>
    </Fragment>
  );
}

export default EditProfileModal;
